import mfeDatalayer from '@mfe/data-layer';

export const datalayerInstance = () => {
  window.gap.datalayer = window.gap.datalayer || mfeDatalayer;
  
  return window.gap.datalayer;
}
